/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRoleListDto } from '../../models/user-role-list-dto';

export interface UserRolesFindAll$Params {
}

export function userRolesFindAll(http: HttpClient, rootUrl: string, params?: UserRolesFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserRoleListDto>>> {
  const rb = new RequestBuilder(rootUrl, userRolesFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserRoleListDto>>;
    })
  );
}

userRolesFindAll.PATH = '/user-roles';
